import InputAdornment from "@mui/material/InputAdornment";

import SearchIcon from "../Asset/Icons/search.svg";
import { FilterTypes } from "../enums/components";
import { formatNumberBasedOnUser } from "./namesManipulation";

export const convertTabelHeadersToFormItems = (headers) => {
  return headers.map((header) => ({
    displayOptionsFn: (formData) => header.displayOptions?.(formData),
    filterName: header.dataKey,
    filterType:
      header.cellType === "dropdown" || typeof header.cellType === "function"
        ? FilterTypes.DROPDOWN_SINGLE
        : FilterTypes.INPUT,
    optionsFn: (formData) => header.options?.(formData),
    props: {
      label: header.label,
      type: header.contentType ?? "string",
    },
  }));
};

export const getRoundedNumericColumn = ({ dataKey, ...props }) => {
  return getTableTypicalColumn({
    dataKey,
    valueTransformation: (row) => tableRoundedValueTransformation(row[dataKey]),
    ...props,
  });
};

export const getTypicalDropDownColumn = ({ dataKey, displayOptions, options, ...props }) => {
  return getTableTypicalColumn({
    cellType: "dropdown",
    dataKey,
    displayOptions: () => displayOptions ?? options,
    options: () => options,
    ...props,
  });
};

export const getTableTypicalColumn = ({ dataKey, ...props }) => {
  return {
    dataKey,
    isInDefault: true,
    label: props?.label || dataKey,
    valueTransformation: (row) => row[dataKey],
    ...props,
  };
};

export const getTableTypicalAutocompleteColumn = ({ ...props }) => {
  return getTableTypicalColumn({
    cellType: "autocomplete",
    minWidth: "20rem",
    valueComponentProps: {
      inputRootClassName: "font-ds-body-regular-md ",
      listboxClassName: "font-ds-body-regular-md ",
    },
    ...props,
  });
};

export const tableRoundedValueTransformation = (value) => {
  return formatNumberBasedOnUser(value, 2);
};

const booleanDisplayOptions = {
  NO: "No",
  YES: "Yes",
};

export const typicalBooleanColumnOptions = {
  displayOptions: [booleanDisplayOptions.NO, booleanDisplayOptions.YES],
  options: [false, true],
};

export const typicalBooleanValueTransformation = (value) => {
  return value === true ? booleanDisplayOptions.YES : value === false ? booleanDisplayOptions.NO : value;
};

export const searchInputEndAdornment = {
  endAdornment: (
    <InputAdornment position="end">
      <img alt="Search Icon" src={SearchIcon} />
    </InputAdornment>
  ),
};
